import VcChordDiagram from './components/vc-chord-diagram/index'

export default VcChordDiagram



// WEBPACK FOOTER //
// ./src/lib.js